import { NotificationTypeValues } from '../../graphql.generated';

export const enabledDynamicNotificationTypes = (
    showMojoNotification?: boolean
) => [
    NotificationTypeValues.HomeEstimateChanged,
    NotificationTypeValues.LocalMarketUpdate,
    NotificationTypeValues.PlanningApplication,
    NotificationTypeValues.NewSimilarChanged,
    ...(showMojoNotification ? [NotificationTypeValues.GetMortgage] : [])
];
